<template>
  <div class="editPage" v-loading="subLoading">
  <!--    地图 start-->
  <section class="mapBox">
    <MapForm ref="mapForm" @distanceDetail="distanceDetail" @startPoint="startPoint"
    @endPoint="endPoint"></MapForm>
  </section>
  <!--    地图 end-->

  <!--    表单 start-->
  <section class="editBox">
    <BaseForm  ref="baseForm" @pathTypeChange="pathTypeChange"></BaseForm>
    <div class="subBtnBox" v-if="!$route.query.id">
      <el-button class="btn cancelBtn" @click="cancel">取消
      </el-button>
      <el-button class="btn" type="primary" @click="sub">保存
      </el-button>
    </div>

    <div class="subBtnBox" v-else>
      <el-button class="btn cancelBtn" @click="cancel">返回
      </el-button>
    </div>

  </section>
  <!--    表单 end-->

  </div>
</template>

<script>
import pageDataMixin from '@qx/mixin/pageData';
import BaseForm from './baseForm';
import MapForm from './mapForm';
import {doQueryPlanningInfoList, doSavePlanningInfo} from 'api/operate';
import {getDepartmentAllList} from 'api/index';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    MapForm,
  },
  data () {
    return {
      pageUrl: '/manage/operate/track/pathPlanning/edit',
      formComponents: ['baseForm'],
      editParams: {
        lineId: this.$route.query.lineId,
      },
      subLoading: false,
    };
  },
  computed: {
    detailParams () {
      return {
        id: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: doQueryPlanningInfoList,
    editApi: doSavePlanningInfo,
    cancel () {
      this.close();
    },
    pathTypeChange (pathOrigin, pathEndPoint, pathType) {
      this.$refs.mapForm.pathTypeChange(pathOrigin, pathEndPoint, pathType);
    },
    distanceDetail (time, distance, steps, startInfo, endInfo) {
      this.$refs.baseForm.distanceDetail(time, distance, steps, startInfo, endInfo);
    },
    startPoint (val) {
      this.$refs.baseForm.startPoint(val);
    },
    endPoint (val) {
      this.$refs.baseForm.endPoint(val);
    },
  },
  async mounted () {
    if (this.$refs.baseForm) {
      const orgIdOptions = await getDepartmentAllList();
      this.$refs.baseForm.setList({orgIdOptions});
    }
    this.getData();
  },
};
</script>

<style scoped lang="scss">
.editPage{
  //position: relative;
  padding-bottom: 0;
  display: flex;


  //地图
  .mapBox{
    width:75%;
    height: 821px;

    //.map{
    //  width: 100%;
    //  height: 100%;
    //}
  }

  .editBox{
    width: 25%;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding:20px 0px 20px 20px;

    .subBtnBox{
      display: flex;
      align-items: center;
      justify-content: center;
      .btn {
        width: 160px;
        height: 40px;
      }
      .cancelBtn {
        margin-right: 24px;
      }
    }


    //.subBtnBox{
    //  //width: 0;
    //  //background: #fff;
    //  bottom: 38px;
    //  right: 22px;
    //  background: rgba(255, 255, 255, 0);
    //}
  }

}


</style>
